import {
  datetimeLocalValueToIso,
  isoToDatetimeLocalValue,
} from '@/lib/publishing/calendarMonth';
import { MIN_SCHEDULE_LEAD_MS } from '@/lib/publishing/isScheduledAtTooSoon';

/** Local `datetime-local` value at or after now + 2 minutes.
 *  `datetime-local` has minute precision, so now + 2m is ceiled to the next
 *  local minute before formatting. Truncating would rebuild at :00 and often
 *  land back under the 2-minute floor. */
export function minScheduleDatetimeLocal(now: Date, timeZone: string): string {
  const earliestMs = now.getTime() + MIN_SCHEDULE_LEAD_MS;
  const truncated = isoToDatetimeLocalValue(new Date(earliestMs).toISOString(), timeZone);
  const truncatedMs = Date.parse(datetimeLocalValueToIso(truncated, timeZone) ?? '');
  if (Number.isFinite(truncatedMs) && truncatedMs >= earliestMs) return truncated;
  const nextMs = Number.isFinite(truncatedMs) ? truncatedMs + 60_000 : earliestMs + 60_000;
  return isoToDatetimeLocalValue(new Date(nextMs).toISOString(), timeZone);
}
